import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { NAV, AUTH } from "../constants/testIds";
import { LayoutDashboard, ClipboardList, Kanban, Users, Package, Boxes, BarChart3, Settings, LogOut, Factory, ShieldCheck, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { Toaster } from "../components/ui/sonner";

const ITEMS = [
  { to: "/", label: "Gösterge Paneli", icon: LayoutDashboard, testid: NAV.dashboard, roles: ["admin", "operator"] },
  { to: "/board", label: "Üretim Panosu", icon: Kanban, testid: NAV.board, roles: ["admin", "operator"] },
  { to: "/matching", label: "Eşleştirme", icon: Sparkles, testid: NAV.matching, roles: ["admin"] },
  { to: "/orders", label: "Siparişler", icon: ClipboardList, testid: NAV.orders, roles: ["admin"] },
  { to: "/customers", label: "Müşteriler", icon: Users, testid: NAV.customers, roles: ["admin"] },
  { to: "/products", label: "Ürünler ve Reçeteler", icon: Package, testid: NAV.products, roles: ["admin"] },
  { to: "/inventory", label: "Stok ve Hammadde", icon: Boxes, testid: NAV.inventory, roles: ["admin"] },
  { to: "/reports", label: "Raporlar", icon: BarChart3, testid: NAV.reports, roles: ["admin"] },
  { to: "/users", label: "Kullanıcılar", icon: ShieldCheck, testid: NAV.users, roles: ["admin"] },
  { to: "/settings", label: "Ayarlar", icon: Settings, testid: NAV.settings, roles: ["admin"] },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const items = ITEMS.filter((i) => i.roles.includes(user?.role));

  return (
    <div className="min-h-screen flex bg-slate-50">
      <aside className="w-64 shrink-0 bg-white border-r border-slate-200 flex flex-col">
        <div className="px-5 py-5 border-b border-slate-100 flex items-center gap-2">
          <div className="h-8 w-8 rounded-md bg-slate-900 flex items-center justify-center">
            <Factory className="h-4 w-4 text-blue-400" />
          </div>
          <div>
            <div className="font-display font-extrabold text-slate-900 leading-none">ATÖLYE</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">ERP · v1.0</div>
          </div>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              data-testid={it.testid}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              <it.icon className="h-4 w-4" />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-100">
          <div className="flex items-center gap-3 px-2 py-2 mb-2">
            <div className="h-9 w-9 rounded-full bg-blue-600 text-white grid place-items-center font-bold">
              {(user?.name || "?").slice(0, 1).toUpperCase()}
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-slate-900 truncate">{user?.name}</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">
                {user?.role === "admin" ? "Yönetici" : "Operatör"}
              </div>
            </div>
          </div>
          <Button data-testid={AUTH.logoutBtn} onClick={logout} variant="outline" className="w-full justify-start gap-2 text-slate-600 hover:text-slate-900">
            <LogOut className="h-4 w-4" /> Çıkış Yap
          </Button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
}
